export default __webpack_public_path__ + "static/media/imgu.44b30afe.webp";